import LearningResultReportData from './LearningResultReportData';

export default LearningResultReportData;
